<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <Attributes />
    </v-container>
  </div>
</template>
<script>
import Attributes from "../../components/Definiciones/Atributos/Attributes.vue";
import LandingToolbar from "@/components/LandingToolbar/LandingToolbar.vue";

export default {
  components: { LandingToolbar, Attributes },
};
</script>
